import React from 'react';

import NextImage, { StaticImageData } from 'next/image';
import ContentLoader from 'react-content-loader';
import { twMerge } from 'tailwind-merge';

import { AppStoreButtons } from '../../../Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { Heading } from '../../../Heading/Heading';
import { Text } from '../../../Text/Text';
import backgroundDark from '../assets/backgroundDark.jpg';
import phoneCatchPins from '../assets/phoneCatchPins.png';
import { QRCode } from '../../../QRCode/QRCode';

export enum TextVariant {
  xs = 'xs',
  sm = 'sm',
}

interface IProps {
  textVariant?: TextVariant;
  headingText?: string;
  headingClassName?: string;
  subHeadingText?: string;
  phoneImage?: StaticImageData;
  imageWrapperClassname?: string;
  isLoading?: boolean;
}

export const DownloadAppContent = ({
  textVariant = TextVariant.sm,
  headingText,
  headingClassName,
  subHeadingText,
  phoneImage,
  imageWrapperClassname,
  isLoading,
}: IProps) => {
  if (isLoading) {
    return (
      <div
        className="flex h-[700px] w-full flex-col rounded-md bg-cover bg-center bg-no-repeat py-6 sm:min-w-[332px]"
        data-testid="DownloadAppVerticalCTALoader"
      >
        <ContentLoader
          uniqueKey="download-app-loader-key"
          className="flex size-full items-center justify-center"
        >
          <rect x="0" y="0" rx="5" ry="5" width="100%" height={700} />
        </ContentLoader>
      </div>
    );
  }
  return (
    <div
      className="flex w-full flex-col rounded-md bg-cover bg-center bg-no-repeat py-6 sm:min-w-[300px]"
      style={{
        backgroundImage: `url(${backgroundDark.src})`,
      }}
      data-testid="DownloadAppVerticalCTA"
    >
      <div className="flex flex-col items-center justify-center px-8">
        <Heading
          className={twMerge(`text-sea-foam text-center`, headingClassName)}
          variant={textVariant}
        >
          {headingText ?? 'Fishbrain is better in the app'}
        </Heading>
        {subHeadingText && (
          <Text className="text-tuna-tint mt-2 mb-0 text-center font-semibold">
            {subHeadingText}
          </Text>
        )}
        <div
          className={twMerge(`flex h-full w-full items-center px-10 py-4`, imageWrapperClassname)}
        >
          <NextImage
            placeholder="blur"
            alt="Fishbrain app"
            width={238}
            height={477}
            className="mx-auto"
            src={phoneImage || phoneCatchPins}
          />
        </div>
      </div>
      <div className="flex w-full items-center justify-center sm:gap-3 sm:px-16 lg:gap-4">
        <div className="flex w-full items-center justify-center sm:w-auto sm:justify-end">
          <AppStoreButtons orientation="vertical" source="DownloadAppContent" />
        </div>
        <QRCode
          size={120}
          imageSize={35}
          className="hidden w-auto sm:flex"
          source="DownloadAppContent"
          showOnMobileDevice
        />
      </div>
    </div>
  );
};
